import ManageMakeModelInfoPage from './ManageMakeModelInfoPage';
import { checkUserRole } from '../../Auth';
import { UserRole } from '../../../models';

export default checkUserRole(ManageMakeModelInfoPage, [UserRole.superAdmin], '/admin');
export { default as reducer } from './makeModelInfo.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageMakeModelInfoPage/index.ts